import { memo } from 'react';

import { useTranslateFn } from '../Translate';

import type { SingleSponsorProps } from './SingleSponsor';
import SingleSponsor from './SingleSponsor';

import type { Sponsor } from '@shared-types/sponsor.types';

import * as classes from './styles.module.scss';

export type SponsorGroupProps = {
  sponsors: Sponsor[];
  titleTag: string;
  showSponsorName?: boolean;
  position?: SingleSponsorProps['position'];
  creative?: SingleSponsorProps['creative'];
};

const SponsorsGroup = ({ sponsors, titleTag, showSponsorName, position, creative }: SponsorGroupProps) => {
  const t = useTranslateFn();

  return (
    <div className='pk-w--100'>
      <div className={classes.sponsorLabel}>{t(titleTag)}</div>
      <ul className={classes.sponsorList}>
        {sponsors.map((s) => (
          <SingleSponsor
            key={`local-sponsor_${s.code}`}
            sponsor={s}
            showSponsorName={showSponsorName}
            position={position}
            creative={creative}
          />
        ))}
      </ul>
    </div>
  );
};

export default memo(SponsorsGroup);
